import { getDataToConvert } from './getDataToConvert'

export const convertDecimalToFraction = (
  unit,
  parsedQuantity,
  quantity,
  isSpice = false
) => {
  let fraction = ''
  let leaveAsDecimal =
    !isSpice &&
    (unit === 'ml' || unit === 'cl' || unit === 'dl' || unit === 'g')

  let unitWithDecimalPoint = unit === 'l' || unit === 'kg'

  const isLessThanOne = parseFloat(parsedQuantity) < 1

  const fractionConverter = getDataToConvert(isSpice, isLessThanOne)
  const splitQuantity = parsedQuantity.toString().split(',')

  fractionConverter.forEach(item => {
    if (item.key === splitQuantity[1] && !leaveAsDecimal) {
      splitQuantity.pop()
      splitQuantity.push(item.value)
    }

    if (splitQuantity[0] === '0') {
      splitQuantity[0] = ''
    }
    //kg + l auf eine Nachkommastelle
    fraction = leaveAsDecimal
      ? Math.round(quantity)
      : unitWithDecimalPoint
        ? Math.round(quantity * 10) / 10
        : splitQuantity.join(' ')
  })
  return fraction
}
